import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import OtpModal from "./OTPModal";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomSnackbar from "../../../newTestPreo/components/snackbar/Snackbar";
import { renewToken } from "../../../api";
import ServiceModal from "../registrationform/serviceModal";
import phoneRules from "../../components/phoneRules";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const labelStyle = {
  fontFamily: "Inter, sans-serif",
  fontWeight: 600,
  fontSize: "18px",
  marginBottom: "6px",
  display: "block",
};

function LoginPage2() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [mobileError, setMobileError] = useState("");

  const [isdCodeList, setIsdCodeList] = useState([]);
  const [countryCode, setCountryCode] = useState("91");
  const [focused, setFocused] = useState(false);

 const [otpOpen, setOtpOpen] = useState(false);
const [otpUserData, setOtpUserData] = useState(null);
const [serviceOpen, setServiceOpen] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [logoutMessage, setLogoutMessage] = useState("");
  const [loginMode, setLoginMode] = useState("mobile"); // "mobile" | "email"

  const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    fetch(`${API_ENDPOINT}countries`)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = [...data].sort(
          (a, b) => a.phone_code - b.phone_code,
        );
        const uniqueArray = sortedData.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.phone_code === obj.phone_code),
        );
        setIsdCodeList(uniqueArray);
      })
      .catch((error) => console.error("Error fetching country:", error));
  }, []);

  useEffect(() => {
    const sessionExpired = localStorage.getItem("loggedOutDueToSessionExpired");
    const loggedOutDueToInactivity = localStorage.getItem(
      "loggedOutDueToInactivity",
    );

    if (sessionExpired === "true") {
      setLogoutMessage("Your session has expired. Please log in to continue.");
    } else if (loggedOutDueToInactivity === "true") {
      setLogoutMessage(
        "You were logged out due to inactivity. Please log in again.",
      );
    }

    localStorage.removeItem("loggedOutDueToSessionExpired");
    localStorage.removeItem("loggedOutDueToInactivity");
  }, []);

  const handleGenerateOTP = async (e) => {
    e.preventDefault();

    let payload = {
      for_login: 1,
      email: null,
      mobile: null,
      mobile_country_code: null,
    };

    // 🔹 EMAIL MODE
    if (loginMode === "email") {
      if (!email.trim()) {
        showSnackbar("Email is required", "error");
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        showSnackbar("Enter a valid email address", "error");
        return;
      }

      payload.email = email;
    }

    // 🔹 MOBILE MODE
    if (loginMode === "mobile") {
      const rules = phoneRules[countryCode] || phoneRules.default;
      const { min, max } = rules;

      if (!mobile.trim()) {
        setMobileError("Mobile number is required");
        return;
      }

      if (!/^\d+$/.test(mobile)) {
        setMobileError("Mobile number must contain digits only");
        return;
      }

      if (mobile.length < min || mobile.length > max) {
        setMobileError(
          min === max ? `Enter ${min} digits` : `Enter ${min}–${max} digits`,
        );
        return;
      }

      setMobileError("");

      payload.mobile = mobile;
      payload.mobile_country_code = countryCode;
    }

    // 🔹 API CALL (COMMON FOR BOTH)
    try {
      localStorage.clear();

      const response = await fetch(
        `${API_ENDPOINT}studentsignup/register/generatingotp?platform=1`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      if (response.ok) {
        setOtpUserData(result.data);
        showSnackbar("OTP sent successfully!", "success");
        setOtpOpen(true);
      } else {
        showSnackbar(result.message || "Error sending OTP", "error");
      }
    } catch (error) {
      showSnackbar("Error sending OTP", "error");
    }
  };

  const handleOtpLogin = async (otp) => {
    let payload = {
      otp: parseInt(otp),
      email: null,
      mobile: null,
      mobile_country_code: null,
    };

    if (loginMode === "email") {
      payload.email = email;
    } else {
      payload.mobile = mobile;
      payload.mobile_country_code = countryCode;
    }

    try {
      const response = await fetch(
        `${API_ENDPOINT}auth/verify/loginotp?platform=1`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (response.ok) {
        const result = await response.json();
        const {
          first_name,
          last_name,
          token,
          user_id,
          services,
          is_registration_form,
          target_country_id,
          broad_field_id,
          narrow_field_id,
          is_enrolled,
          login_count,
          highest_level_id,
          enq_personal_detail_id,
          mobile,
        } = result?.data || {};

        localStorage.setItem("userId", user_id);
        localStorage.setItem("token", token);
        localStorage.setItem("firstName", first_name || "");
        localStorage.setItem("lastName", last_name || "");
        localStorage.setItem("lastActivity", Date.now().toString());
        localStorage.setItem("targetCountryId", target_country_id || "");
        localStorage.setItem("broadFieldId", broad_field_id);
        localStorage.setItem("narrowFieldId", narrow_field_id || "");
        localStorage.setItem("isEnrolled", is_enrolled);
        localStorage.setItem("loginCount", login_count);
        localStorage.setItem("highestLevelId", highest_level_id);
        localStorage.setItem(
          "enquiryPersonalDetailId",
          enq_personal_detail_id || "",
        );
        localStorage.setItem("mobile", mobile);

        const scholarsProgram = services?.find(
          (service) =>
            service.service_name === "Scholars Admission Program" &&
            service.enrolled,
        );

        if (scholarsProgram?.program) {
          localStorage.setItem("program", scholarsProgram.program);
        } else {
          localStorage.removeItem("program");
        }

        setInterval(() => renewToken(user_id), 100 * 60 * 1000);

        if (is_registration_form) {
          setOtpOpen(false);
          setServiceOpen(true);
          return;
        }

        if (services?.[1]?.status === "active") {
          navigate("/sap/dashboard");
        } else if (services?.[0]?.status === "active") {
          navigate("/test-prep/testprepdashboard");
        } else {
          navigate("/login");
        }
      } else {
        const result = await response.json();
        showSnackbar(result.message || "Invalid OTP", "error");
      }
    } catch (error) {
      console.error(error);
      showSnackbar(
        "An unexpected error occurred. Please try again later.",
        "error",
      );
    }
  };

  return (
    <Grid
      container
      minHeight="100vh"
      sx={{
        fontFamily: "Inter, sans-serif",
        position: "relative",
        backgroundImage: `url('/Signupimages/loginBg.png')`,
        backgroundSize: { xs: "cover", sm: "cover", md: "cover" },
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",

        // HANDLE ULTRAWIDE SCREENS
        "@media (min-width:1600px)": {
          backgroundSize: "120%",
        },

        // HANDLE EXTRA SMALL DEVICES (≤360px)
        "@media (max-width:360px)": {
          px: 1,
        },
      }}
    >
      {/* LEFT SIDE */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          p: { xs: 2, sm: 3, md: 6 },
          color: "#fff",
          textAlign: { xs: "center", md: "left" },

          // Prevent overflow on small devices
          "@media (max-width:400px)": {
            mt: 2,
          },
        }}
      >
        <Box
          mb={3}
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: "flex-start" },
          }}
        >
          <img
            src="/Signupimages/logo.png"
            alt="Logo"
            style={{ width: "90px", height: "auto" }}
          />
        </Box>

        <Box sx={{ mt: "auto", mb: { xs: 4, md: 6 } }}>
          <Typography
            sx={{
              fontFamily: "Crimson Pro",
              fontWeight: 800,
              fontStyle: "normal",
              fontSize: { xs: "28px", sm: "34px", md: "50px" },
              lineHeight: "105%",
              letterSpacing: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",

              // Prevent line break issues on small screens
              "@media (max-width:350px)": {
                fontSize: "24px",
              },
            }}
          >
            Test to Take <br /> off All in One.
          </Typography>
        </Box>
      </Grid>

      {/* RIGHT WHITE CARD */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          position: "relative",
          borderRadius: "20px",
          zIndex: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: { xs: 2, sm: 3, md: 6 },

          "@media (max-width:400px)": {
            pt: 4,
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", sm: 420, md: 520 },
            backgroundColor: "#fff",
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(20,20,20,0.08)",
            p: { xs: 3, sm: 4, md: 5 },
            boxSizing: "border-box",
            position: "relative",
            overflow: "visible",
            pb: { xs: 10, md: 12 },

            // PREVENT CARD OVERFLOW ON SMALL PHONES
            "@media (max-width:350px)": {
              p: 2,
              pb: 10,
            },
          }}
        >
          {/* TOP RIGHT IMAGE */}
          <Box
            component="img"
            src="/Signupimages/map.png"
            sx={{
              position: "absolute",
              top: -1,
              right: 3,
              borderRadius: "20px",
              width: { xs: 100, sm: 150, md: 220 },
              pointerEvents: "none",

              "@media (max-width:350px)": {
                width: 80,
              },
            }}
          />

          {/* BOTTOM WAVE */}
          <Box
            component="img"
            src="/Signupimages/bottomWave.png"
            sx={{
              position: "absolute",
              borderRadius: "20px",
              bottom: -1,
              left: "50%",
              transform: "translateX(-50%)",
              width: { xs: 160, sm: 240, md: 520 },
              pointerEvents: "none",

              "@media (max-width:350px)": {
                width: 140,
              },
            }}
          />

          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: "22px", // Smaller Title
              color: "#161719",
              mb: 1,
            }}
          >
            Login to Your{" "}
            <span
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: "22px",
                color: "#3D025B",
              }}
            >
              Global Dream
            </span>
          </Typography>

          {/* Sub Heading */}
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 500,
              fontSize: "14px", // Smaller subtitle
              color: "#4A4A4A",
              mb: 5,
            }}
          >
            Continue your personalized study abroad <br /> journey, right where
            you left off.
          </Typography>

          {/* Logout message box (if present) */}
          {logoutMessage && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                mb: 3,
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#fff",
                  border: "1px solid #572575",
                  borderLeft: "4px solid #572575",
                  borderRadius: "8px",
                  padding: "12px 16px",
                  textAlign: "center",
                  width: "100%",
                  boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    color: "#111",
                  }}
                >
                  {logoutMessage}
                </Typography>
              </Box>
            </Box>
          )}

          {/* Form */}
          <form onSubmit={handleGenerateOTP}>
            {/* Inline label styled with Inter */}
            {loginMode === "mobile" && (
              <>
                <Box
                  component="label"
                  sx={{
                    display: "block",
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 600,
                    fontSize: "16px",
                    mb: 1,
                    color: "#111",
                  }}
                >
                  Enter your Mobile number{" "}
                  <span style={{ color: "red" }}>*</span>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #E5E5E5",
                    borderRadius: "12px",
                    padding: "6px 14px",
                    height: "50px",
                    gap: 2,
                  }}
                >
                  {/* Flag + Code Box (inner small rounded box) */}
                  <TextField
                    select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    variant="standard"
                    disableUnderline
                    sx={{
                      minWidth: "95px",
                      maxWidth: "95px",
                      background: "#fff",
                      border: "1px solid #E5E5E5",
                      borderRadius: "10px",
                      height: "36px",
                      display: "flex",
                      alignItems: "center",
                      "& .MuiSelect-select": {
                        padding: "6px 8px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "14px",
                        fontWeight: 500,
                      },
                      "& .MuiInput-root": {
                        padding: 0,
                      },
                    }}
                    SelectProps={{
                      renderValue: () => {
                        const selected = isdCodeList.find(
                          (i) => i.phone_code == countryCode,
                        );

                        if (!selected) return null;

                        return (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <img
                              src={`https://flagcdn.com/w20/${selected.locale_code.toLowerCase()}.png`}
                              alt={selected.locale_code}
                              style={{
                                width: 22,
                                height: 14,
                                borderRadius: 3,
                                objectFit: "cover",
                              }}
                            />
                            <span
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "14px",
                                fontWeight: 500,
                              }}
                            >
                              +{countryCode}
                            </span>
                          </Box>
                        );
                      },
                    }}
                  >
                    {isdCodeList.map((option) => (
                      <MenuItem
                        key={option.locale_code}
                        value={option.phone_code}
                        sx={{ fontFamily: "Inter, sans-serif" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <img
                            src={`https://flagcdn.com/w20/${option.locale_code.toLowerCase()}.png`}
                            alt={option.locale_code}
                            style={{ width: 22, height: 14, borderRadius: 3 }}
                          />
                          +{option.phone_code}
                        </Box>
                      </MenuItem>
                    ))}
                  </TextField>

                  {/* Mobile */}
                  <TextField
                    variant="standard"
                    value={mobile}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, "");
                      const rules =
                        phoneRules[countryCode] || phoneRules.default;
                      setMobile(value.slice(0, rules.max));
                    }}
                    placeholder="Enter your mobile number"
                    fullWidth
                  />
                </Box>
              </>
            )}

            {loginMode === "email" && (
              <>
                <Box
                  component="label"
                  sx={{
                    display: "block",
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 600,
                    fontSize: "16px",
                    mb: 1,
                    color: "#111",
                  }}
                >
                  Enter your Email <span style={{ color: "red" }}>*</span>
                </Box>

                <TextField
                  variant="standard"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  fullWidth
                />
              </>
            )}

            {mobileError && (
              <Typography
                sx={{
                  mt: 1,
                  fontSize: "12px",
                  fontFamily: "Inter, sans-serif",
                  color: "#d32f2f",
                }}
              >
                {mobileError}
              </Typography>
            )}

            <Typography
              sx={{
                mt: 1,
                fontSize: "14px",
                fontFamily: "Inter, sans-serif",
                color: "#572575",
                cursor: "pointer",
                fontWeight: 500,
              }}
              onClick={() =>
                setLoginMode(loginMode === "mobile" ? "email" : "mobile")
              }
            >
              {loginMode === "mobile"
                ? "Login with email"
                : "Login with mobile"}
            </Typography>

            {/* Send OTP Button (large purple pill) */}
            <Button
              type="submit"
              fullWidth
              sx={{
                mt: 5,
                py: 1.6,
                backgroundColor: "#572575",
                color: "#fff",
                fontWeight: 700,
                fontFamily: "Inter, sans-serif",
                borderRadius: "12px",
                boxShadow: "0 8px 18px rgba(87,37,117,0.22)",
                "&:hover": { backgroundColor: "#572575" },
              }}
            >
              Send OTP
            </Button>
          </form>

          {/* Signup link */}
          <Box mt={3} mb={8} textAlign="center">
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "15px",
                fontWeight: 500,
                color: "#333",
              }}
            >
              Don’t Have An Account?{" "}
              <a
                href="/"
                style={{
                  color: "#572575",
                  fontWeight: 700,
                  textDecoration: "none",
                  fontFamily: "Inter, sans-serif",
                }}
              >
                Sign Up Here
              </a>
            </Typography>
          </Box>

          {/* Bottom illustration (positioned) */}
          <Box
            component="img"
            src="/Signupimages/lockLogin.png"
            alt="illustration"
            sx={{
              position: "absolute",
              bottom: -18,
              right: 24,
              width: { xs: 160, md: 260 },
              pointerEvents: "none",
            }}
          />
        </Box>
      </Grid>

      <OtpModal
        open={otpOpen}
        onClose={() => setOtpOpen(false)}
        onVerify={(enteredOtp) => handleOtpLogin(enteredOtp)}
        loginMode={loginMode}
        mobile={otpUserData?.mobile}
        countryCode={otpUserData?.mobile_country_code}
        email={otpUserData?.email}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <ServiceModal open={serviceOpen} onClose={() => setServiceOpen(false)} />
    </Grid>
  );
}

export default LoginPage2;
